<template>
  <div class="increment">
    <div class="title-con">
      <span class="title">喜马拉雅用户数据：</span>
      <el-select v-model="curCityId" placeholder="请选择城市" v-loading="initLoading" @change="switchCity">
        <el-option
          v-for="item in basicData"
          :key="item.cityId"
          :label="item.cityName"
          :value="item.cityId">
        </el-option>
      </el-select>
    </div>
    <p class="dataMsg" v-if="dataMsg">{{dataMsg}}</p>
    <div class="dashboard" v-for="itemCity in basicData" v-if="itemCity.cityId === curCityId">
      <div class="nums-board">
        <p class="title">昨日关键数据<span class="oHelp forTitle">?</span></p>
        <ul class="board-content">
          <li class="board-content-item" v-for="keyItem in numsKey">
            <div class="count-nums">
              <span>{{itemCity[`${keyItem.key}Count`]}}</span>
              <p>{{keyItem.name}}</p>
            </div>
            <ul class="percents">
              <li class="percent-item" v-for="typeItem in keyItem.dateType">
                <span class="typeItem">{{typeItem.name}}<span class="oHelp forType" v-if="typeItem.name=='周'">?</span></span>
                <div class="dataBlock">
                  <span class="up" v-if="itemCity[`${keyItem.key}Compare${typeItem.key}`].indexOf('-')===-1">▲</span>
                  <span class="down" v-else-if="itemCity[`${keyItem.key}Compare${typeItem.key}`] !== '0%'">▼</span>
                  <span>{{itemCity[`${keyItem.key}Compare${typeItem.key}`]}}</span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="charts-board">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="7">
            <el-radio-group v-model="curChart" fill="#f86442" @change="switchChart">
              <el-radio-button label="active">活跃用户数</el-radio-button>
              <el-radio-button label="newUser">新增用户数</el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="6">
            <el-radio-group v-model="curChartRegion" @change="switchChartRegion">
              <el-radio-button label="7">7天</el-radio-button>
              <el-radio-button label="15">15天</el-radio-button>
              <el-radio-button label="30">30天</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <echarts :options="lineChart" v-loading="chartLoading"></echarts>
      </div>
    </div>
    <div class="table-con">
      <el-row type="flex" class="row-bg title" justify="space-between" v-if="basicData">
        <el-col :span="7">
          <el-date-picker v-model="dateRange" @change="switchTableRegion" type="daterange" placeholder="选择日期" :editable="false" :clearable="false"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <a class="el-button el-button--primary" :class="tableData.length && !tableLoading ? '':'is-disabled'" :href="`/report/active/export?city=${exportParams().city}&start=${exportParams().startDate}&end=${exportParams().endDate}`" target="_blank" ><i class="el-icon-document"></i><span class="exportText">导出表格</span></a>
        </el-col>
      </el-row>
      <el-table :data="tableData" stripe style="width: 100%" v-if="tableData" v-loading="tableLoading">
        <el-table-column :prop="iKey.key" :label="iKey.label" :label-class-name="iKey.key" :width="iKey.width" v-for="iKey in incrementKey" :key="iKey.key" sortable show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <p class="oTip forTitle">部分数据因为用户未授权地理位置权限，无法获取地理位置，没有显示在本表中，请悉知。</p>
    <p class="oTip forType">昨日数据和上周日均数据的对比</p>
  </div>
</template>

<script>
  import { incrementData, chartRegionData, tableRegionData, exportTable } from '../../api'
  import { parseTime } from '../../utils'
  import echarts from 'vue-echarts/components/ECharts'
  import 'echarts/lib/chart/line'
  import 'echarts/lib/component/tooltip'

  export default {
    data() {
      return {
        numsKey: [
          {
            key: 'active',
            name: '活跃用户数',
            dateType: [
              {
                key: 'Day',
                name: '日'
              },
              {
                key: 'Week',
                name: '周'
              }
            ]
          },
          {
            key: 'newUser',
            name: '新增用户数',
            dateType: [
              {
                key: 'Day',
                name: '日'
              },
              {
                key: 'Week',
                name: '周'
              }
            ]
          }
        ],
        lineChart: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              label: {
                show: true
              }
            }
          },
          xAxis: {
            name: '',
            type: 'category',
            axisLabel: {
              showMinLabel: true
            },
            axisTick: {
              length: 5
            },
            data: []
          },
          yAxis: {
            name: '',
            type: 'value'
          },
          series: [
            {
              name: '',
              type: 'line',
              data: [],
              label: {
                emphasis: {
                  show: true
                }
              }
            }
          ],
          animationDuration: 2000
        },
        incrementKey: [
          {
            key: 'date',
            label: '时间',
            width: 280,
          },
          {
            key: 'activeCount',
            label: '活跃用户数',
            width: 280,
          },
          {
            key: 'newUserCount',
            label: '新增用户数',
            width: 280,
          }
        ],
        initLoading: false,
        basicData: null,
        tableData: null,
        recentDataLen: null,
        dateRange: [],
        curCityId: '',
        curCityIdx: 0,
        curChart: 'active',
        curChartRegion: "7",
        chartLoading: false,
        tableLoading: false,
        dataMsg: ''
      }
    },
    components: {
      echarts
    },
    methods: {
      hoverTip(target, tip) {
        let oTarget = document.querySelectorAll(target);
        let oTip = document.querySelectorAll(tip);
        // console.log(oTarget, oTip)
        let hoverFn = function (e) {
          let { clientX, clientY } = e;
          for (var i = 0; i < oTip.length; i++) {
            oTip[i].style.display = 'block';
            oTip[i].style.top = (clientY - 130) + 'px';
            oTip[i].style.left = (clientX - 135) + 'px';
          }
        }
        let outFn = function () {
          for (var i = 0; i < oTip.length; i++) {
            oTip[i].style.display = 'none';
            oTip[i].style.top = 0;
            oTip[i].style.left = 0;
          }
        }
        for (var i = 0; i < oTarget.length; i++) {
          oTarget[i].onmouseover = hoverFn;
          oTarget[i].onmousemove = hoverFn;
          oTarget[i].onmouseout = outFn;
        }
      },
      fillChart(data) {
        let _this = this;
        // reset
        _this.lineChart.xAxis.data = [];
        _this.lineChart.series[0].data = [];

        let tmpX = [], tmpY = [];
        data.forEach((item,idx) => {
          tmpX[idx] = item.date.replace('2017-','');
          tmpY[idx] = item[`${_this.curChart}Count`];
        })
        // fill
        _this.lineChart.xAxis.data = tmpX;
        _this.lineChart.series[0].data = tmpY;
        _this.chartLoading = false;
      },
      fillTable(data) {
        let _this = this;
        _this.tableData = data;
        _this.tableLoading = false;
      },
      switchCity(curCityId) {
        let _this = this;
        _this.chartLoading = true;
        _this.tableLoading = true;
        // reset
        _this.curChart = 'active';
        _this.curChartRegion = '7';
        _this.basicData.forEach((item,idx) => {
          if(item.cityId === curCityId){
            _this.curCityIdx = idx;
            _this.recentDataLen = item.recentData.length;
          }
        })
        if(_this.recentDataLen){
          _this.dateRange = [];
          _this.dateRange[0] = new Date(_this.basicData[_this.curCityIdx].recentData[0].date);
          _this.dateRange[1] = new Date(_this.basicData[_this.curCityIdx].recentData[_this.recentDataLen-1].date);
        }
        _this.switchChart(_this.curChart);
        _this.fillTable(_this.basicData[_this.curCityIdx].recentData);
        _this.$nextTick(() => {
          _this.hoverTip('.oHelp.forTitle', '.oTip.forTitle');
          _this.hoverTip('.oHelp.forType', '.oTip.forType');
        })
      },
      switchChart(curChart) {
        let _this = this;
        _this.chartLoading = true;
        let chartName = _this.numsKey.filter(i => { return i.key === curChart })[0].name;
        _this.lineChart.xAxis.name = '日期';
        _this.lineChart.yAxis.name = chartName;
        _this.lineChart.series[0].name = chartName;
        _this.switchChartRegion(_this.curChartRegion)
      },
      switchChartRegion(curChartRegion) {
        let _this = this;
        _this.chartLoading = true;
        chartRegionData({city: _this.curCityId, region: curChartRegion}).then(res => {
          _this.fillChart(res.data)
        })
      },
      switchTableRegion(dateRange) {
        let _this = this;
        _this.tableLoading = true;
        let city = _this.curCityId;
        let start = dateRange.split(' - ')[0] || '';
        let end = dateRange.split(' - ')[1] || '';
        tableRegionData({city, start, end}).then(res => {
          _this.fillTable(res.data)
        })
      },
      exportParams() {
        let _this = this;
        let city = _this.curCityId;
        let startDate = '', endDate = '';
        if(_this.dateRange.length){
          startDate = parseTime(_this.dateRange[0]).replace(/\s\d+\:\d+\:\d+/g,'');
          endDate = parseTime(_this.dateRange[1]).replace(/\s\d+\:\d+\:\d+/g,'');          
        }
        return {city, startDate, endDate}
      }
    },
    created() {
      let _this = this;
      _this.initLoading = true;
      incrementData().then(res => {
        _this.initLoading = false;
        // res.ret = 0;
        // res.data = [
        //   {
        //     date: "2017-11-14",
        //     cityId: "431100",
        //     cityName: "北京市市辖区",
        //     activeCount: 635105,
        //     activeCompareDay: "2.09%",
        //     activeCompareWeek: "5.67%",
        //     newUserCount: 2758,
        //     newUserCompareDay: "-16.60%",
        //     newUserCompareWeek: "-4.16%",
        //     recentData: [
        //     {
        //       date: "2017-11-08",
        //       activeCount: 623369,
        //       newUserCount: 2910,
        //       t: 1510070400000
        //     },
        //     {
        //       date: "2017-11-09",
        //       activeCount: 616944,
        //       newUserCount: 2306,
        //       t: 1510156800000
        //     },
        //     {
        //       date: "2017-11-10",
        //       activeCount: 593098,
        //       newUserCount: 2489,
        //       t: 1510243200000
        //     },
        //     {
        //       date: "2017-11-11",
        //       activeCount: 549228,
        //       newUserCount: 2517,
        //       t: 1510329600000
        //     },
        //     {
        //       date: "2017-11-12",
        //       activeCount: 577896,
        //       newUserCount: 3306,
        //       t: 1510416000000
        //     },
        //     {
        //       date: "2017-11-13",
        //       activeCount: 622082,
        //       newUserCount: 3307,
        //       t: 1510502400000
        //     },
        //     {
        //       date: "2017-11-14",
        //       activeCount: 635105,
        //       newUserCount: 2758,
        //       t: 1510588800000
        //     }
        //     ]
        //   }
        // ]
        if(res.ret === 0){
          if(res.data.length){
            _this.basicData = res.data;
            _this.curCityId = _this.basicData[_this.curCityIdx].cityId;
            _this.tableData = _this.basicData[_this.curCityIdx].recentData;
          }
        }else{
          _this.dataMsg = res.msg;
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
.increment{
  width: 840px;
}
.dataMsg{
  padding: 10px;
  color: #ccc;
  background-color: #fff;
}
.title-con{
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-bottom: 10px;
  font-size: 18px;
  background-color: #fff;
}
.dashboard{
  background-color: #fff;
  padding: 20px;
}
.nums-board{
  position: relative;
  .title{
    display: flex;
    align-items: center;
    padding: 5px 10px;
    font-size: 14px;
    background-color: #efefef;
  }
  .board-content{
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    border-top: 0 none;
  }
  .board-content-item{
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px;
    margin-right: 0;
    padding-right: 20px;
    border-right: 1px solid #ccc;
    &:last-child{
      border: 0 none;
    }
    .count-nums{
      width: 200px;
      margin-right: 20px;
      text-align: center;
      span{
        font-size: 32px;
        color: #f86442;
      }
      p{
        font-size: 16px;
      }
    }
    .percents{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: space-between;
      .percent-item{
        display: flex;
        justify-content: space-between;;
        align-items: center;
        font-size: 14px;
        .typeItem{
          display: flex;
          align-items: center;
        }
        .dataBlock{
          display: flex;
          justify-content: space-between;
          width: 60%;
        }
        .up{
          color: rgba(255, 0, 0, 0.7);
        }
        .down{
          color: #3CB371;
        }
      }
    }
  }
}
.charts-board{
  margin-top: 20px;
  .echarts{
    margin: 20px auto 0;
  }
}
.table-con{
  margin-bottom: 56px;
  .title{
    padding: 10px 18px;
    font-size: 18px;
    color: #333;
    background-color: #fff;
  }
  .exportText{
    margin-left: 5px;
  }
  .is-disabled{
    pointer-events: none;
  }
}
.oHelp{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  font-size: 12px;
  color: #fff;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #1f2d3d;
  cursor: pointer;
  user-select: none;
  &.forType{
    margin-left: 2px;
    transform: scale(0.75);
  }
}
.oTip{
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  padding: 8px;
  font-size: 14px;
  color: #333;
  max-width: 114px;
  color: #fff;
  background-color: #1f2d3d;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// incrementData.vue?c603eb12